<p>
<label [attr.for]="'natural_input_' + randomId">{{labelInput}} <span class="sr-only" *ngIf="highlight">{{highlightLabel}}</span></label> <span *ngIf="mandatory" class="mandatory">*</span>
<input [attr.id]="'natural_input_' + randomId" #dinput [class]="'form-control' + getHighlight()" maxlength="{{maxLength}}" min= "{{minValue}}" (ngModelChange)="onChange($event)"
	type='{{type}}' [placeholder]="'Inserire '+labelInput" [(ngModel)]="_value"
	(blur)='onBlur();'  [disabled]="submitPending" [attr.aria-required]="mandatory" (keypress)="validate($event)" [attr.aria-describedby]="'errorMessage_' + randomId"/>
<small style="color:#e60000;" aria-live="assertive" aria-atomic="true" id="errorMessage_{{randomId}}">&nbsp;
        <ng-template [ngIf]="control && !control.valid && checkFormat && _value">
        	Formato non valido
    	</ng-template>
</small>
</p>